import WebFont from "webfontloader";
import $ from "jquery";
import gsap from "gsap";
import DataManager from "../../data/DataManager";
import RankingManager from "../../ranking/RankingManager";
import Fader from "../../common/Fader";
import GameOverView from "../../gameover/GameOverView";
import RankingView from "../../ranking/RankingView";

import * as PIXI from "pixi.js";
import { RGBSplitFilter } from "pixi-filters";

import AsseetsManager from "../../pixi/AssetsManager";
import MyApplication from "../../pixi/MyApplication";
import TopView from "./top/TopView";
import GameView from "./game/GameView";
import MathUtil from "../../util/MathUtil";
import SoundButton from "../../common/SoundButton";
import Intro from "../../common/Intro";
import TimeUtil from "../../util/TimeUtil";

/**
 * Mainクラス
 */
class App {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //コンフィグデータ
  private _config: any;

  //PIXIアプリケーション
  private _app: PIXI.Application;

  //TOP画面
  private _top: TopView;

  //ゲーム画面
  private _game: GameView;

  //ゲームオーバー画面
  private _gameOverView: GameOverView;

  //ランキング画面
  private _rankingView: RankingView;

  //サウンドボタン
  private _soundBtn: SoundButton;

  //コピーライト
  private _copyright: PIXI.Sprite;

  //エフェクト関連
  private _rgb: RGBSplitFilter;
  public rgbVal: number;
  public rgbRot: number;

  // ---------------------------------------------------------------------------------------------------------
  // --	App
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    console.log("App:::jetpanda ");

    //ログを削除
    console.log = function () {
      // do nothing.
    };

    //フォントの読み込みへ
    window.onload = () => {
      if (document.getElementById("game") != null) {
        this.setupForGame();
      } else {
        window.onresize = this.onResizeParent.bind(this);
        this.onResizeParent();
      }
    };
  }

  /**
   * Game用にセットアップ
   */
  setupForGame(): void {
    //フォント読み込み
    this.loadFonts();
  }

  /**
   * フォント読み込み
   */
  loadFonts() {
    WebFont.load({
      custom: {
        families: [
          "PixelMplus12-Regular",
          "PixelMplus12-Bold",
          "PixelMplus10-Regular",
          "PixelMplus10-Bold",
          "BIT",
        ],
      },
      loading: () => {},
      active: this.loadConfig.bind(this),
      inactive: () => {},
    });
  }

  /**
   * Config読み込み
   */
  loadConfig() {
    $.getJSON("config.json")
      .done((json) => {
        this._config = json;
        DataManager.instance.setData("config", this._config);
        // this.setup()
        this.loadAssets();
      })
      .fail(() => {
        throw new Error("config.jsonの読み込みに失敗しました");
      })
      .always(() => {});
  }

  /**
   * アセット読み込み
   */
  async loadAssets() {
    const bundle = this._config.BUNDLE;
    await AsseetsManager.instance.loadBundle(bundle.name, bundle.assets);
    this.setup();
  }

  /**
   * セットアップ
   */
  async setup() {
    console.log("setup");

    //PIXIアプリケーション参照
    this._app = MyApplication.app;
    this._app.renderer.background.color = 0xaae7ff;

    //ラインキング初期化
    RankingManager.instance.init();

    //ランキング画面
    this._rankingView = new RankingView();

    //ゲームオーバー画面
    this._gameOverView = new GameOverView();
    this._gameOverView.on("RETRY", this.onRetry.bind(this));
    this._gameOverView.on("RANKING", this.onRanking.bind(this));

    //トップ画面
    this._top = new TopView();
    this._top.emitter.on("START", this.onGameStart.bind(this));
    this._top.emitter.on("RANKING", this.onRanking.bind(this));
    this._app.stage.addChild(this._top);

    //ゲーム画面
    this._game = new GameView();
    this._game.emitter.on("MISS", this.missEffect.bind(this));
    this._game.emitter.on("OVER", this.onGameOver.bind(this));
    this._app.stage.addChild(this._game);

    //サウンドボタン配置
    this._soundBtn = new SoundButton();
    this._app.stage.addChild(this._soundBtn);

    //コピーライト
    this._copyright =
      AsseetsManager.instance.createSpriteByName("copyright.png");
    this._copyright.anchor.set(0.5, 1);
    this._copyright.scale.set(2);
    this._app.stage.addChild(this._copyright);

    //エフェクトの初期化
    this.initFilter();

    //リサイズハンドリング
    window.onresize = this.onResize.bind(this);
    this.onResize();

    //スタート
    this.start();
  }

  /**
   * スタート
   */
  async start() {
    //フェードイン
    await Fader.instance.fadeIn();

    //イントロ
    const intro: Intro = new Intro();
    await intro.start();

    //フェードアウト
    await Fader.instance.fadeOut();

    //ボタンの初期化
    this._soundBtn.init();

    //間をあける
    await TimeUtil.wait(500);

    //イントロ破棄
    intro.destroy();

    //ゲーム画面リセット
    this._game.reset();

    //フェードイン
    await Fader.instance.fadeIn();

    //トップ画面開く
    this._top.open();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	GAME
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ゲームスタート
   */
  onGameStart() {
    //SE
    AsseetsManager.instance.playSound("sound_click");

    //TOP閉じる
    this._top.close();

    //GAME開く
    this._game.open();

    //コピーライト消す
    this._app.stage.removeChild(this._copyright);
  }

  /**
   * ゲームオーバー
   */
  onGameOver(score: number) {
    this._gameOverView.open(score);
  }

  /**
   * リトライ
   */
  onRetry() {
    // window.location.reload();
    //SE
    AsseetsManager.instance.playSound("sound_click");

    //オーバー画面を消す
    this._gameOverView.clsoe();

    //ゲーム再開
    this._game.resetGame();
    this._game.start();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	エフェクト関連
  // ---------------------------------------------------------------------------------------------------------

  /**
   * フィルターの初期化
   */
  initFilter() {
    this._rgb = new RGBSplitFilter();
    this._app.stage.filters = [this._rgb];

    this.rgbVal = 0;
    this.rgbRot = 0;
    this.updateRGB();
  }

  missEffect() {
    gsap.killTweensOf(this);
    gsap.set(this, { rgbVal: 60 });
    this.updateRGB();

    gsap.to(this, {
      duration: 2.4,
      rgbVal: 0,
      rgbRot: this.rgbRot + 720,
      ease: "elastic.out(1, 0.3)",
      onUpdate: this.updateRGB.bind(this),
    });
  }

  updateRGB() {
    const redRadian = MathUtil.degreeToRadian(this.rgbRot + 180);
    this._rgb.red = [
      Math.cos(redRadian) * this.rgbVal,
      Math.sin(redRadian) * this.rgbVal,
    ];

    const greenRadian = MathUtil.degreeToRadian(this.rgbRot + 90);
    this._rgb.green = [
      Math.cos(greenRadian) * this.rgbVal,
      Math.sin(greenRadian) * this.rgbVal,
    ];

    const blueRadian = MathUtil.degreeToRadian(this.rgbRot - 45);
    this._rgb.blue = [
      Math.cos(blueRadian) * this.rgbVal,
      Math.sin(blueRadian) * this.rgbVal,
    ];
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	RANKING
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ランキング表示
   */
  onRanking() {
    //SE
    AsseetsManager.instance.playSound("sound_click");

    this._rankingView.open();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	リサイズ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * リサイズハンドリング
   */
  onResize() {
    //PIXIアプリケーションのリサイズ
    MyApplication.resize();

    //TOP画面リサイズ
    this._top.resize();

    //GAME画面リサイズ
    this._game.resize();

    //コピーライト
    this._copyright.x = MyApplication.screenWidth / 2;
    this._copyright.y = MyApplication.screenHeight - 20;
  }

  /**
   * リサイズ（親）
   */
  onResizeParent(): void {
    // console.log("onResizeParent");

    //アイフレーム
    const $iframe: JQuery = $(".c-parent__iframe");

    //画面サイズ
    const winW: number = window.innerWidth;
    const winH: number = window.innerHeight;

    // console.log("winW:", winW);
    // console.log("winH:", winH);

    const scale: number = Math.min(winW / 640, winH / 900);
    // console.log("scale:", scale);

    $iframe.css("width", 640 * scale + "px");
    $iframe.css("height", "100%");
  }

  // ---------------------------------------------------------------------------------------------------------
}

new App();
